// Grab the respective environment's login url
import { geoClipRectangle } from 'd3';
import { PLAYER_ENV, NEW_ADMIN_URL } from 'environment';

// Main angular app config
function appConfig($httpProvider, $locationProvider, $routeProvider, $analyticsProvider) {

    // Injector error thrown as $location isn't ready right away
    // This is a documented issue with implementation of angulartics:
    // https://github.com/angulartics/angulartics/issues/29
    $analyticsProvider.firstPageview(false);
    $analyticsProvider.virtualPageviews(false);
    // Track exceptions with angular's $exceptionHandler decorator.
    $analyticsProvider.trackExceptions(true);
    // Prevent sending analytics unless we're in prod.
    if (PLAYER_ENV !== 'prod') {
        $analyticsProvider.developerMode(true);
    }

    // Router html5 configuration and 404 handling
    $locationProvider.html5Mode(true).hashPrefix('!');
    $routeProvider.otherwise({ redirectTo: '/' });

    // Pass token on request and force users to login again if token is invalid
    return $httpProvider.interceptors.push(($injector, $q, $window) => {
        return {
            request(config) {
                let token = $window.localStorage.oauthAdminToken;
                if (config.url.match(/__no_auth__/)) {
                  return config
                }
                if (config.url.match(/^https:\/\/[^\.]+(\.dev)?.boxcast.com\//) || config.url.match(/^http:\/\/localhost:3000\//)) {
                    if (!config.headers['Authorization']) {
                        config.headers['Authorization'] = `Bearer ${token}`;
                    }
                }
                return config;
            },

            responseError(rejection) {
                const { data } = rejection;
                const status = rejection.status || 0;
                if (status === 401 && data.error === 'invalid_token') {
                    $injector.get('AuthService').redirectToLogin();
                }
                else if (status >= 400 && data && !rejection.config['Interceptor-Ignore-Errors']) {
                    let message = `ERROR ${status}`;
                    if (data.error) message += ` (${data.error})`;
                    if (data.error_description) message += `\n\n${data.error_description}`;
                    if (data.invalid_fields && _.size(data.invalid_fields) > 0) message += `\n\nInvalid fields: ${JSON.stringify(data.invalid_fields)}`;
                    alert(message);
                    let origin = $window.location.origin
                    let path = $window.location.pathname
                    $window.location.replace(origin+path)
                }
                return $q.reject(rejection);
            }
        };
    });
}

// Main angular app run block
function appRun($window, $rootScope) {

    let token = $window.localStorage.oauthAdminToken;
    let { hash } = $window.location;
    if (hash.indexOf('token_type=bearer') >= 0) {
        let i = hash.indexOf('access_token=') + 13;
        let j = hash.indexOf('&', i);
        token = hash.substring(i, j);
        if (token && (token.length > 0)) {
            $window.localStorage.oauthAdminToken = token;
            $window.location.replace($window.localStorage.oauthAdminPath || '/');
            throw new Error('halt');
        }
    }

    // Template helpers
    $rootScope._ = _;

    // Track page views
    $rootScope.$on("$routeChangeSuccess", function(e, next, current) {
        if (next && $window.location.pathname) {
            gtag('set', 'page_location', $window.location.pathname);
            gtag('event', 'page_view', $window.location.pathname);
        };
    });

    // Open URL helpers
    $rootScope.openURL = function(url, $event) {
        var $location = angular.element(document.body).injector().get("$location");
        if ($event.metaKey) {
            window.open(url, '_blank');
        }
        else if (url.includes(NEW_ADMIN_URL)) {
            window.open(url, '_self');
        }
        else {
            $location.url(url);
        }
    };
}

export { appConfig, appRun };



// WEBPACK FOOTER //
// ./app.config.js